import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, concatMap } from 'rxjs/operators';
import * as departmentActions from '../action/units-statistics-departments.actions';
import { AdministratorStatisticsService } from '../../../../../../services/administrator-statistics.service';

@Injectable()
export class UnitsStatisticsDepartments {
   constructor(
      private actions$: Actions,
      private administratorStatistics: AdministratorStatisticsService
   ) {}

   /**
    * Effect listening for DepartmentsStatistics Action, when DepartmentsStatistics is dispatched the effect with call create() from courseService.
    * In case of success response the effect it will trigger DepartmentsStatisticsSuccess.
    * In case of Error it will trigger DepartmentsStatisticsFailure with error property.
    */
   DepartmentsStatistics$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(departmentActions.loadUnitsStatisticsDepartments),
         concatMap((action) => {
            return this.administratorStatistics
               .academicUnitsDepartmentsStatistics(
                  action.page,
                  action.title,
                  action.faculty
               )
               .pipe(
                  map((data) => {
                     return departmentActions.loadUnitsStatisticsDepartmentsSuccess(
                        {
                           data: data,
                        }
                     );
                  }),
                  catchError((error) =>
                     of(
                        departmentActions.loadUnitsStatisticsDepartmentsFailure(
                           {
                              error,
                           }
                        )
                     )
                  )
               );
         })
      );
   });
}
